module.exports = __webpack_public_path__ + "img/inclusivity.7badbcf0.jpg";